export default {
  customer: 'Customer',
  'form.button.submit': 'Create Order',
  'form.button.cancel': 'Cancel',
  'form.button.reset': 'Reset',
};
